module.exports = __webpack_public_path__ + "img/stones@2x.b9fd986.jpg";